import moment from 'moment'

export const getPaginatedEvents = (events, page) => {
  const start = (page - 1) * 10
  const end = start + 10
  return {
    data: events.slice(start, end),
    total: events.length,
    totalPages: Math.ceil(events.length / 10),
  }
}

export const getPaginatedSimilarEvents = (events, page, startDate = null, endDate = null) => {
  let eventsToPaginate = events
  
  if (startDate && endDate) {
    eventsToPaginate = eventsToPaginate.filter((event) => {
      const eventDate = event.start_date_time
        ? moment(event.start_date_time).format('YYYY-MM-DD')
        : event.date

      return eventDate >= startDate && eventDate <= endDate
    })
  }
  
  const start = (page - 1) * 10
  const end = start + 10
  return {
    data: eventsToPaginate.slice(start, end),
    total: eventsToPaginate.length,
    totalPages: Math.ceil(eventsToPaginate.length / 10),
  }
}